window.addEventListener('vite:preloadError', () => {
    window.location.reload()
})
